module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0wIDBoMTcwLjY2NnY1MTJIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZjAiIGQ9Ik0xNzAuNjY2IDBoMTcwLjY2NnY1MTJIMTcwLjY2NnoiLz4KICAgIDxwYXRoIGZpbGw9IiMwOTAiIGQ9Ik0zNDEuMzMyIDBoMTcwLjY2NXY1MTJIMzQxLjMzMnoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gn.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gn.svg
// module chunks = 0